import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@ninety/ui/web/environments';

export interface FinTokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

@Injectable({ providedIn: 'root' })
export class FinApiService {
  private http = inject(HttpClient);

  getFinToken(): Observable<FinTokenResponse> {
    return this.http.post<FinTokenResponse>(`${environment.authApiOrigin}/v1/fin/token`, {});
  }
}
